import React, {useEffect, useRef} from "react";
import {Box, Typography} from "@mui/material";
import style from "./LandingPage.module.scss";

type LandingPageProps = {
    guardianImage: string;
    guardianName: string;
    guardianMessage: string;
    copyrightInfo?: string;
};

export const LandingPage = ({
                                guardianImage,
                                guardianName,
                                guardianMessage,
                                copyrightInfo
                            }: LandingPageProps) => {
    const copyRightInfoRef = useRef<any>(null);
    //-----------------------------------------------------------------------------------------------
// Dynamically set CSS variable for navbar height to ensure content is not hidden behind it
    useEffect(() => {
        const updateCopyrightHeight = () => {
            const height = copyRightInfoRef.current?.offsetHeight || 0;
            console.log("CopyRightInfo height:", height);
            document.documentElement.style.setProperty(
                "--copyright-message-height",
                `${height}px`
            );
        };

        updateCopyrightHeight(); // lần đầu

        window.addEventListener("resize", updateCopyrightHeight);

        return () => {
            window.removeEventListener("resize", updateCopyrightHeight);
        };
    }, []);
    //

    return (
        <Box className={`${style.landingPage} scam-edu-ladingpage`}>
            {/* Guardian Image */}
            <Box className={style.guardianWrapper}>
                <img src={guardianImage} alt={guardianName} className={style.guardianImage}/>
            </Box>

            {/* Guardian Message */}
            <Box className={style.messageWrapper}>
                <Typography variant="body1" className={style.guardianMessage}>
                    {/*<Box className={"MuiMessage"}>*/}
                        {guardianMessage}
                    {/*</Box>*/}
                </Typography>
            </Box>
            {copyrightInfo &&
                <Box className={style.messageWrapper2}>
                    <Box className={"MuiCopyrightInfo"} ref={copyRightInfoRef}>
                        {copyrightInfo}
                    </Box>
                </Box>
            }
        </Box>
    );
};
